export default __webpack_public_path__ + "static/media/zombiestories_subject_blur.2386fb99.png";